module.exports = __webpack_public_path__ + "fonts/3107C8_6_0.4387db9.ttf";